import APP_MAIN_HEADER_URL_TYPE from '../types/AppMainHeaderUrlType.js';

const AppMainHeaderUrlReducer= (state = initialState,action)=>{
    switch(action.type){
        case APP_MAIN_HEADER_URL_TYPE:
            return Object.assign({}, state, { appMainHeaderUrl: action.data });
        default:
            return state;
    }
};


const initialState = {
    appMainHeaderUrl: ''
};

export default AppMainHeaderUrlReducer;
